import UserService from '@/services/requests/userService'
import Store from '@/store/computed/storeHelpers'
export default {
  methods: {
    getUserAuthClasses() {
      this.loadingUserAuthClasses = true;
      UserService.getAllUserAuthClasses().then(result => {
        //console.log(result);
        this.loadingUserAuthClasses = false;
        this.userAuthClasses = result.data.result;
      }).catch(err => {
        console.log(err);
        this.loadingUserAuthClasses = false;
        this.snackError();
      })
    }
  },
  computed: {
    loadingUsers: Store.getSet({ store: 'users', prop: 'loadingUserAuthClasses' }),
    userAuthClasses: Store.getSet({ store: 'users', prop: 'userAuthClasses' }),
    fetchUserAuthClasses: Store.getSet({ store: 'users', prop: 'fetchUserAuthClasses' })
  },
  mounted() {
    if (!this.userAuthClasses.length) {
      this.getUserAuthClasses()
    }
  },
  beforeDestroy() {
    if (!this.keepMasterFiles) this.userAuthClasses = [];
  },
  watch: {
    fetchUserAuthClasses(val) {
      if (val) {
        this.fetchUserAuthClasses = false
        this.getUserAuthClasses()
      }
    }
  }
}